module.exports = __webpack_public_path__ + "media/images/logo_ins_vivienda-2b011b9c18324976c41eca94aa13da5a.png";